module.exports = __webpack_public_path__ + "static/default_background-47d5cc154a6778cfca9bf0c6e784ed93.jpg";